import React from "react"
import {FormControlLabel, Radio, RadioGroup} from "@mui/material"
import {makeStyles} from "tss-react/mui"

const useStyles = makeStyles()({
	container: {
		display: "flex",
		alignItems: "center",
	},
})
interface EventsRadioGroupProps {
	value: string
	onChange: (eventsType: string) => void
}

export default function EventsRadioGroup(props: EventsRadioGroupProps) {
	const {classes} = useStyles()
	const [value, setValue] = React.useState<string>(props.value)
	const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = event.target.value
		setValue(newValue)
		props.onChange(newValue)
	}
	return (
		<div className={classes.container}>
			<RadioGroup row value={value} onChange={handleRadioChange}>
				<FormControlLabel
					value="keyEvents"
					label="Key Events"
					control={<Radio color="primary" />}
				/>
				<FormControlLabel
					value="allEvents"
					label="All Events"
					control={<Radio color="primary" />}
				/>
				<FormControlLabel value="warnings" label="Warnings" control={<Radio color="primary" />} />
				<FormControlLabel value="updates" label="Updates" control={<Radio color="primary" />} />
			</RadioGroup>
		</div>
	)
}
